import { io } from "socket.io-client";
import { getBaseApi } from "config/Environment";
export const Socket = io(getBaseApi(), { transports: ["websocket"] });
